import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import { Box, CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    setCarregando(true);
    api
      .get("carrinhos/ativos")
      .then((res) => {
        setCarregando(false);
        setLista(res);
      })
      .catch((err) => {
        notification(
          "error",
          "Erro ao listar os vouchers de frete disponíveis."
        );
      });
  };

  const abrirCarrinho = (registro) => {
    history.push(`/app/carrinho/carrinho/${registro.usuarioId}`);
  };

  const tRegistros = {
    title: "Carrinhos Ativos",
    onLineClick: abrirCarrinho,
    newItemAction: () => history.push(`/app/carrinho/catalogo`),
    columns: [
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
      {
        name: "usuarioNome",
        label: "Profissional",
      },
    ],
    array: lista,
  };

  return (
    <div>
      {carregando ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
